import React, { Fragment } from 'react';
import { inject } from 'mobx-react';

@inject('songsStore')
class SongListHeadings extends React.Component {
	render () {
		return (
			<div className="grid-x align-justify align-middle song-header-row">
				<div className="cell shrink">
					<div style={ { width: '1.5rem', height: '2rem' } }>
						&nbsp;
					</div>
				</div>
				<div className="cell small-4 margin-left-1">
					<strong>Title</strong>
				</div>

				<div className="cell small-5">
				</div>

				<div className="cell auto text-center">
					<strong>Duration</strong>
				</div>
				<div className="cell small-1">
				</div>

				{ this.props.songsStore.showAdminOptions && this.renderEditorHeadings() }
			</div>
		);
	}

	renderEditorHeadings () {
		const { trackListMode } = this.props;

		if (trackListMode) {

			return null;
		}

		return (
			<Fragment>
				<div className="cell small-1 text-center">
					<strong>Explicit</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Plays</strong>
				</div>

				<div className="cell small-1 text-center">
					<strong>Hi Fives</strong>
				</div>
			</Fragment>
		);
	}
}

export default SongListHeadings;
